<template>
    <span class="paragraph-widget">
        <div
            :class="{'editable': !readOnly, 'ql-editor': !0}"
            @click="edit"
            v-html="contents"
            ref="paragraph"
            v-if="mode == 'view'"
        ></div>

        <quill-editor
            ref="editor"
            v-model="editor"
            v-if="mode == 'edit'"
            :options="editorOptions"
            @blur="onEditorBlur($event)"
            @focus="onEditorFocus($event)"
            @ready="onEditorReady($event)"
        />

        <div class="mt-5">
            <button v-if="mode == 'edit'" class="btn btn-sm btn-success" v-on:click="save">{{ $t('save') }}</button>
            <button v-if="mode == 'edit'" class="btn btn-sm" v-on:click="cancel">{{ $t('cancel') }}</button>
            <button v-if="mode == 'edit'" class="btn btn-sm btn-danger" v-on:click="destroy">{{ $t('delete') }}</button>
        </div>
    </span>
</template>

<script>
    import widgetMixin from '../../mixins/widgetMixin.js';
    import { quillEditor } from 'vue-quill-editor';

    import Quill from 'quill'

    var FontAttributor = Quill.import('attributors/class/font');
    FontAttributor.whitelist = ['roboto'];
    Quill.register(FontAttributor, true);

    import 'quill/dist/quill.core.css'; // import styles
    import 'quill/dist/quill.snow.css' // for snow theme

    export default {
        components: {
            quillEditor,
        },
        mixins: [widgetMixin],
        props: {
            id: Number,
            readOnly: {
                type: Boolean,
                default: true,
            },
        },
        data: function () {
            return {
                mode: 'view',
                editor: '',
                editorOptions: {
                    placeholder: this.$i18n.t('content_placeholder'),
                    modules: {
                        toolbar: [
                            ['bold', 'italic', 'underline'],
                            ['link'],
                            [{ 'list': 'ordered'}, { 'list': 'bullet' }],
                        ]
                    },
                },
            }
        },
        computed: {
            contents: {
                set: function (value) {
                    this.widget.contents = value.replace(/\n/g, '<br />');
                },
                get: function () {
                    return this.widget.contents;
                }
            },
            contentsRaw: function () {
                return (this.contents)
                    ? this.contents.replace(/<br \/>/g, '\n')
                    : '';
            },
        },
        methods: {
            onEditorBlur: function ($event) {
                // do nothing for now
            },
            onEditorFocus: function ($event) {
                // do nothing for now
            },
            onEditorReady: function ($event) {
                // do nothing for now
            },
            beforeSaveCallback: function () {
                this.contents = this.editor;
                this.mode = 'view';
            },
            edit: function () {
                if (this.readOnly) {
                    return false;
                }

                var height = this.$refs.paragraph.scrollHeight;

                this.editor = this.contentsRaw;
                this.mode = 'edit';
            },

            cancel: function () {
                this.editor = this.widget.contents;
                this.mode = 'view';

                if (!this.contents) {
                    this.destroy(true);
                }
            },
        },
        mounted: function () {
            if (this.widget.contents == '' && !this.readOnly) {
                this.mode = 'edit';
            }
        },
        updated: function () {
            if (this.mode == 'edit') {
                var editor = this.$refs.editor.quill;

                editor.focus();
            }
        },
    }
</script>



// WEBPACK FOOTER //
// resources/js/components/widgets/ParagraphWidget.vue